import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as firebase from "firebase";
import { ImageResult, ResizeOptions } from 'ng2-imageupload';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit, OnDestroy {
    form: FormGroup;
    formErrors: any;
    files: any[] = [];
    categories: Observable<any>;
    imageName: any;
    queryString: any;
    imageName2: any;
    imageName4: any;
    text: any;
    imageName3: any;
    files2: any[] = [];
    files3: any[] = [];
    files4: any[] = [];
    tags = [];
    isUploading = false;
    public progress: number;
    itemIndex: any = null;
    resizeOptions: ResizeOptions = {
        resizeMaxHeight: 128,
        resizeMaxWidth: 128
    };
    urls = new Array<string>();
    urls2 = new Array<string>();
    urls4 = new Array<string>();
    urls3 = new Array<string>();
    public tools: object = {
        items: ['Image']
    };


    constructor(private formBuilder: FormBuilder, private afs: AngularFirestore, private activatedRoute: ActivatedRoute) {

        this.formErrors = {
            text: {},
            textTitle: {},
            category: {},
            tags: {}

        };
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            text: ['', Validators.required],
            textTitle: ['', Validators.required],
            category: ['', Validators.required],
            text2: ['', Validators.required],
            tags: ['', Validators.required],
            author: [''],
            description: ['']




        });
        this.categories = this.afs.collection('blogCategories').valueChanges();
        this.queryString = this.activatedRoute.snapshot.queryParams['key'];
        console.log(this.queryString);
        if (this.queryString) {
            this.afs.collection('blog').doc(this.queryString).ref.get().then(data => {
                this.form = this.formBuilder.group({
                    text: data.data().text,
                    textTitle: data.data().title,
                    category: data.data().category,
                    text2: data.data().text2,
                    author: data.data().author,
                    tags: [''],
                    description: data.data().description




                });
                this.tags = data.data().tags;
                this.imageName = data.data().coverImage,
                    this.imageName2 = data.data().bannerImage,
                    this.imageName3 = data.data().bannerImage2


            });

        }
    }
    detectFiles(event) {
        this.urls = [];
        let files = event.target.files;
        if (files) {
            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.urls.push(e.target.result);
                    console.log(e.target.result);
                    var storageRef = firebase.storage().ref();
                    let newFileName = this.getGUID();
                    this.imageName = newFileName;

                    var uploadTask = storageRef.child('files/' + newFileName).putString(e.target.result, "data_url");
                    this.upload(uploadTask, () => {
                        let media = {
                            type: "image",
                            name: newFileName
                        };
                        this.files.push(media);






                    });
                }
                reader.readAsDataURL(file);
            }
        }
    }
    detectFiles2(event) {
        this.files2 = [];
        this.urls2 = [];
        let files = event.target.files;
        if (files) {
            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.urls2.push(e.target.result);
                    console.log(e.target.result);
                    var storageRef = firebase.storage().ref();
                    let newFileName = this.getGUID();
                    this.imageName2 = newFileName;

                    var uploadTask = storageRef.child('files/' + newFileName).putString(e.target.result, "data_url");
                    this.upload(uploadTask, () => {
                        let media = {
                            type: "image",
                            name: newFileName
                        };

                        this.files2.push(media);






                    });
                }
                reader.readAsDataURL(file);
            }
        }
    }
    detectFiles3(event) {
        this.files3 = [];
        this.urls3 = [];
        let files = event.target.files;
        if (files) {
            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.urls3.push(e.target.result);
                    console.log(e.target.result);
                    var storageRef = firebase.storage().ref();
                    let newFileName = this.getGUID();
                    this.imageName3 = newFileName;

                    var uploadTask = storageRef.child('files/' + newFileName).putString(e.target.result, "data_url");
                    this.upload(uploadTask, () => {
                        let media = {
                            type: "image",
                            name: newFileName
                        };

                        this.files3.push(media);





                    });
                }
                reader.readAsDataURL(file);
            }
        }
    }
    detectFiles4(event) {
        this.files4 = [];
        this.urls4 = [];
        let files = event.target.files;
        if (files) {
            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.urls4.push(e.target.result);
                    console.log(e.target.result);
                    var storageRef = firebase.storage().ref();
                    let newFileName = this.getGUID();
                    this.imageName4 = newFileName;

                    var uploadTask = storageRef.child('files/' + newFileName).putString(e.target.result, "data_url");
                    this.upload(uploadTask, () => {
                        let media = {
                            type: "image",
                            name: newFileName
                        };

                        this.files4.push(media);





                    });
                }
                reader.readAsDataURL(file);
            }
        }
    }
    getGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    photoUpload(imageResult: ImageResult) {
        console.log("gggg")
        console.log(imageResult)
        let src = imageResult.resized && imageResult.resized.dataURL || imageResult.dataURL;
        var storageRef = firebase.storage().ref();
        let newFileName = this.getGUID();
        console.log(src)
        var uploadTask = storageRef.child('files/' + newFileName).putString(src, "data_url");
        this.upload(uploadTask, () => {
            let media = {
                type: "image",
                name: newFileName
            };
            this.files.push(media);
            console.log(this.files);
        });
    }

    upload(uploadTask, callback) {
        this.isUploading = true;
        uploadTask.then(() => callback());
        // Register three observers:
        // 1. 'state_changed' observer, called any time the state changes
        // 2. Error observer, called on failure
        // 3. Completion observer, called on successful completion
        uploadTask.on('state_changed', (snapshot: firebase.storage.UploadTaskSnapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    break;
            }
        }, (error: firebase.FirebaseError) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;

                case 'storage/canceled':
                    // User canceled the upload
                    break;
                case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    break;
            }
        }, () => {
            this.isUploading = false;
        });
    }
    public blobToFile = (theBlob: Blob, fileName: string): File => {
        var b: any = theBlob;
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.name = fileName;

        //Cast to a File() type
        return <File>theBlob;
    }
    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }
    changeTextCategory(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/-/g, '')
            .replace(/\./g, '-')
            .replace(/\'/g, '')
            .replace(/\s/g, '-').toLowerCase();
    }
    send() {
        console.log(this.form.value.text);

        console.log(this.imageName);
        if (this.imageName && !this.queryString) {
            this.afs.collection('blog').add({
                title: this.form.value.textTitle,
                text: this.form.value.text,
                category: this.form.value.category,
                uniqueName: this.changeText(this.form.value.category),
                coverImage: this.imageName ? this.imageName : '',
                bannerImage: this.imageName2 ? this.imageName2 : '',
                bannerImage2: this.imageName3 ? this.imageName3 : '',
                text2: this.form.value.text2,
                tags: this.tags,
                titleUniqueName: this.changeTextCategory(this.form.value.textTitle.trim()),
                author: this.form.value.author ? this.form.value.author : 'bigadvice',
                description: this.form.value.description


            }).then(data => {
                console.log(data.id);
                this.tags.forEach(tag => {
                    this.afs.collection('blog').doc(data.id).update({
                        ['tag-' + this.changeText(tag.tag)]: true
                    });
                })
            }).then(() => {
                this.form.reset();
                this.tags = [];
                this.imageName = '';
                this.imageName2 = '';
                this.imageName3 = '';
            })
        }
        if (this.queryString) {

            this.afs.collection('blog').doc(this.queryString).update({
                title: this.form.value.textTitle,
                text: this.form.value.text,
                category: this.form.value.category,
                uniqueName: this.changeText(this.form.value.category),
                coverImage: this.imageName ? this.imageName : '',
                bannerImage: this.imageName2 ? this.imageName2 : '',
                bannerImage2: this.imageName3 ? this.imageName3 : '',
                modifyDate: Date.now(),
                text2: this.form.value.text2,
                tags: this.tags,
                author: this.form.value.author ? this.form.value.author : 'bigadvice',
                titleUniqueName: this.changeTextCategory(this.form.value.textTitle.trim()),
                authorImage: this.imageName4 ? this.imageName4 : '',
                description: this.form.value.description

            }).then(() => {
                this.tags.forEach(tag => {
                    this.afs.collection('blog').doc(this.queryString).update({
                        ['tag-' + this.changeText(tag.tag)]: true
                    });
                });
            }).then(() => {
                this.form.reset();
                this.tags = [];
                this.imageName = '';
                this.imageName2 = '';
                this.imageName3 = '';
            })




        }

    }
    onToolbarClick(e: any): void {
        if (e.item != null && e.item.id == "imageRTE_toolbar_Image") { // Checked if image toolbar is clicked 
            let element: any = document.getElementById('imageRTE_upload') // Image uploader element 
            element.ej2_instances[0].uploading = function upload(args) { // Added updating event on image uploader 
                args.currentRequest.setRequestHeader('Authorization', "Bearer ${token}"); // Setting additional headers
            }
        }
    }
    addTags(tags) {
        if (this.itemIndex !== null) {
            this.tags[this.itemIndex].tag = tags;
        }
        else {
            console.log("girdi");
            this.tags.push({ tag: tags });
        }
        this.itemIndex = null;
        this.text = '';

    }
    edit(tag, index) {
        this.text = tag.tag;
        this.itemIndex = index;

    }
    deleteTag(tag) {
        console.log(tag)
        this.tags = this.tags.filter(data => {
            return data.tag !== tag.tag
        });


    }

    ngOnDestroy() {

    }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog/blog.component.ts